'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveRowToolbar, buildActionsForRow } from './BaseResponsiveRowToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileRowToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileRowToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isInDeveloperMode: PropTypes.bool
};
const MockResponsiveMobileRowToolbarWithHideIconToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode,
      canToggleRowVisibility: true
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileRowToolbarWithHideIconToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isInDeveloperMode: PropTypes.bool
};
const MockResponsiveDesktopRowToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: false,
    actions: buildActionsForRow({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveDesktopRowToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isInDeveloperMode: PropTypes.bool
};
export { MockResponsiveMobileRowToolbarToMeasure, MockResponsiveMobileRowToolbarWithHideIconToMeasure, MockResponsiveDesktopRowToolbarToMeasure };